export const getImageHashKeys = ({ id, version }) => {
  const hashKeys = { id, version };
  return Object.values(hashKeys).join('');
};
